import type { Locale } from '@/types/dictionary';
import en, { EnglishDictionary } from './en';
import es from './es';
import fr from './fr';
import de from './de';
import nl from './nl';

const dictionary: Record<Locale, EnglishDictionary> = {
  en,
  es,
  fr,
  de,
  nl,
};

export default dictionary;
